import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as UIActions from '../../actions/ui'
import {
    errorPlaceholder,
    appStoreIcon,
    playStoreIcon,
    inactivePlaceholder,
} from "../../resources/images";
import copy from 'copy-to-clipboard';
import { AppConfig } from '../../configs'
import packageJson from '../../../package.json'

class RedirectPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isError: false,
            placeholder: '',
            title: '',
            caption: '',
        }
    }

    componentDidMount() {
        const { status } = this.props.match.params
        let placeholder = errorPlaceholder
        let title = 'Oopsie!!'
        let caption = 'There is something wrong with this link. Please contact our customer service for more detail.'

        if (status === 'inactive') {
            placeholder = inactivePlaceholder
            title = 'Inactive booking'
            caption = 'The booking is no longer active. If you have any query please contact our customer service.'
        }

        this.setState({
            placeholder,
            title,
            caption
        })
    }

    componentWillUnmount = () => {
        clearInterval(this.startBookingTimer)
    }

    onShow = (modal) => {
        this.setState({
            [modal]: true
        })
    }

    onHide = (modal) => {
        this.setState({
            [modal]: false
        })
    }

    onNav = (type) => {
        switch (type) {
            case 'ios':
                window.open(`https://apps.apple.com/my/app/airasia-travel-delivery/id565050268`);
                return;
            case 'android':
                window.open(`https://play.google.com/store/apps/details?id=com.airasia.mobile&hl=en`);
                return;
            default:
                window.open(`https://tawk.to/chat/5bced00719b86b5920c08a54/default `);
                return;
        }
    }

    copyToClipBoard = (text) => {
        copy(text);
        this.props.showSuccess(`${text} has been copied to clipboard`)
    }

    render() {
        const { placeholder, title, caption } = this.state
        const mainLogo = `${AppConfig.bucketUrl}/Logos/app-logo-ride.png`;
        const { version } = packageJson;

        return (
            <div className="redirectPage">
                <div className="dcHeader">
                    <div className="logoCont">
                        <img src={mainLogo} alt="" className="dcLogo" onClick={() => window.open("https://airasia.com/#/")} />
                        <div className="fDisplay">v{version}</div>
                    </div>
                </div>
                <div className="dcContent">
                    <img src={placeholder} alt="" className="dcImg" />
                    <div className="fDisplay">{title}</div>
                    <div className="fCaption">{caption}</div>
                    <div className="downloadCont">
                        <img src={playStoreIcon} alt="" className="dcAppImg" onClick={() => this.onNav('android')} />
                        <img src={appStoreIcon} alt="" className="dcAppImg" onClick={() => this.onNav('ios')} />
                    </div>
                </div>
            </div>

        );
    }
}



const mapDispatchToProps = (dispatch) => ({
    showSuccess: (message) => dispatch(UIActions.showSuccess(message)),
});

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(RedirectPage)));
